import { render } from "./OnFieldAssessmentResults.vue?vue&type=template&id=4b160e28"
import script from "./OnFieldAssessmentResults.vue?vue&type=script&lang=js"
export * from "./OnFieldAssessmentResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__